import RoleDTO from 'dto/users/roleDTO';
import { Role } from 'models/users/role';

export function mapFromRole(roleDTO: RoleDTO): Role {
  const role = new Role();
  role.roleId = roleDTO.roleId;
  role.systemRoleId = roleDTO.systemRoleId;
  role.name = roleDTO.name ?? '';
  role.description = roleDTO.description;

  return role;
}

export function mapFromRoles(roleDTOs: RoleDTO[] | undefined): Role[] {
  return (roleDTOs ?? []).map((roleDTO) => mapFromRole(roleDTO));
}
